function Banner() {
  return (
    <div className="bannerBox">
      <div className="photoCard">
        <div className="bannerPhoto"></div>
      </div>
      <div className="textBox">
        <div className="bannerText">
          <h1>Geneseo Location</h1>
          <h3>Hours of Operation</h3>
          <h3>Monday Through Friday 9-5</h3>
        </div>
      </div>
    </div>
  );
}

export default Banner;
